class AccountInfoForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.onsubmit = this.submit.bind(this);
  }

  submit(event) {
    event.preventDefault();
    this.clearError();
    
    if (!window.authUrl || window.authUrl == '') return;

    const values = {
      email: this.form.querySelector('input[name="email"]').value,
      password: this.form.querySelector('input[name="password"]').value,
    }
    
    const button = event.target.querySelector('button[type="submit"]');

    button?.classList.add('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    
    try {
      fetch(`${window.authUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "email": values.email,
          "password": values.password,
          "source": "shopify",
        })
      }).then(response => {
        return response.json();
      }).then(data => {
        if (data.redirectURL) {
          const lang = document.querySelector('html').getAttribute('lang');
          let langPath = '';
          if (lang != 'de') {
            langPath = `/${lang}`;
          }
          const redirectUrl = new URL(data.redirectURL);
          window.location.href = window.location.origin + langPath + redirectUrl.pathname + redirectUrl.search;
        } else {
          if (login_form_error_codes[data.error_code]) {
            this.showError(login_form_error_codes[data.error_code], button);
          } else {
            this.showError(data.message, button);
          }
        }
      }).catch(error => {
        this.showError(error.message, button);
        console.error(error);
      }).finally(() => {
        this.querySelector('#login-form-submit').disabled = false;
      });
    } catch (error) {
      
    }

    return false;
  }

  showError(message, button){
    const errorWrapper = this.querySelector('#login-form-errors');
    const errorText = this.querySelector('#login-form-error-message');

    errorText.innerHTML = message;
    errorWrapper.style.display = 'block';
    setTimeout(() => {
      errorWrapper.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }, 500);
    
    button?.classList.remove('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
  }

  clearError(){
    const errorWrapper = this.querySelector('#login-form-errors');
    const errorText = this.querySelector('#login-form-error-message');

    errorText.innerHTML = '';
    errorWrapper.style.display = 'none';
  }
}

customElements.define('login-form', AccountInfoForm);
